export function addCacheQueryParam(urlString: string, cacheValue?: string | string[]): string {
    if (!cacheValue) return urlString;
    try {
        const url = new URL(urlString); // parse full URL with base
        const serializedValue = Array.isArray(cacheValue) ? JSON.stringify(cacheValue) : cacheValue;

        url.searchParams.set('cache', serializedValue);

        return url.toString(); // returns full URL including base, pathname, and query
    } catch (error) {
        console.error('Invalid URL:', error);
        return urlString;
    }
}
